import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import './typography.css'

const H3 = ({ children, className }) => <h2 className={cn('H3', className)}>{children}</h2>

H3.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default H3
